import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export function useNotification() {
  return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
  const [banner, setBanner] = useState(null);

  const showBanner = (message) => {
    setBanner(message);
    // Play sound
    const audio = new Audio('/sos-alert.mp3'); // Place this file in your public folder
    audio.play();
    // Auto-hide after 15 seconds
    setTimeout(() => setBanner(null), 15000);
  };

  return (
    <NotificationContext.Provider value={{ showBanner }}>
      {banner && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', zIndex: 9999,
          background: '#e74c3c', color: '#fff', padding: 20, textAlign: 'center', fontWeight: 'bold', fontSize: 20
        }}>
          🚨 {banner}
        </div>
      )}
      {children}
    </NotificationContext.Provider>
  );
}
